import { useAuth } from '@/context/AuthContext';

/**
 * Shown when the user is authenticated but has no organization membership yet
 * (status: pending_org). Joining/creating orgs stays in the mobile app for V1.
 */
export default function PendingOrgPage() {
  const { user, signOut } = useAuth();

  return (
    <div
      className="flex min-h-screen items-center justify-center p-6"
      style={{ background: 'linear-gradient(135deg, #0D1B2A 0%, #1B263B 50%, #415A77 100%)' }}
    >
      <div className="w-full max-w-md rounded-2xl bg-white p-8 text-center shadow-2xl">
        <img src="/favicon.png" alt="Flock" className="mx-auto mb-4 h-12 w-12" />
        <h1 className="text-xl font-semibold text-flock-navy-900">Almost there</h1>
        <p className="mt-3 text-sm text-flock-navy-500">
          {user?.email ? (
            <>
              <span className="font-medium">{user.email}</span> isn&apos;t part of a church
              community yet.
            </>
          ) : (
            "You aren't part of a church community yet."
          )}
        </p>
        <p className="mt-2 text-sm text-flock-navy-500">
          Open the Flock app on your phone to find your church, accept an invitation, or start a
          group — then come back here.
        </p>
        <button
          onClick={() => signOut()}
          className="min-h-touch mt-6 w-full rounded-lg border border-flock-gray-300 px-4 py-2.5 font-medium text-flock-navy-700 transition hover:bg-flock-navy-50"
        >
          Sign Out
        </button>
      </div>
    </div>
  );
}
